<script setup lang="ts">
import { LogOut, Palette } from '@lucide/vue'
import { DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRoot, DropdownMenuSeparator, DropdownMenuTrigger } from 'reka-ui'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { me, signOut } from '../session'

const router = useRouter()
const initials = computed(() => (me.value?.user.email ?? '?').slice(0, 2).toUpperCase())

async function logout() {
  await signOut()
  await router.push('/login')
}
const itemCls =
  'flex h-8 cursor-pointer items-center gap-2.5 rounded-md px-2 text-[13px] outline-none data-[highlighted]:bg-muted [&_svg]:size-4 [&_svg]:text-muted-foreground'
</script>

<template>
  <DropdownMenuRoot>
    <DropdownMenuTrigger
      class="flex size-9 items-center justify-center rounded-full bg-gradient-to-br from-violet-400 to-violet-700 font-heading text-xs font-semibold text-white ring-2 ring-transparent transition hover:ring-accent-soft"
      aria-label="Account menu"
    >
      {{ initials }}
    </DropdownMenuTrigger>
    <DropdownMenuPortal>
      <DropdownMenuContent align="end" :side-offset="8" class="anim-pop z-50 w-64 rounded-xl border border-border bg-elevated p-1.5 shadow-pop">
        <DropdownMenuLabel class="px-2 py-2">
          <p class="text-[13px] font-medium">{{ me?.tenant.name }}</p>
          <p class="truncate text-xs text-muted-foreground">{{ me?.user.email }}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator class="my-1 h-px bg-border" />
        <DropdownMenuItem :class="itemCls" @select="router.push('/design')"><Palette /> Checkout design</DropdownMenuItem>
        <DropdownMenuSeparator class="my-1 h-px bg-border" />
        <DropdownMenuItem :class="itemCls" @select="logout"><LogOut /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
